import styled from 'styled-components';
import { textLinkSecondary, titleSmall } from 'styles-js/mixins/typography';
import { FadeTop } from 'styles-js/mixins/fade';

// Variables

// Height of fade for fullscreen type on mobile and for responsive type on desktop
export const paddingTop30px = '30px';
// For responsive type on mobile
export const paddingTop20px = '20px';

// Components

export const Header = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-basis: 50px;
  flex-shrink: 0;
  background-color: ${props => props.theme.colorBlueBackground};
  ${FadeTop};
`;

export const Title = styled.span`
  ${titleSmall};
  text-align: center;
  margin: 10px 82px;
  width: 100%;
`;

export const HeaderButton = styled.button.attrs(_ => ({
  className: 'btn',
}))`
  position: absolute;
  margin: 0;
  padding: 10px;
  border: 0;
  -webkit-appearance: none;
  background-color: transparent;
  ${textLinkSecondary};

  .icon {
    font-size: 20px;
  }
`;

export const CloseButton = styled(HeaderButton)`
  right: 0;
`;

export const ResponsiveBodyContainer = styled.div`
  padding: ${paddingTop30px} 40px 40px;
  overflow-y: auto;

  @media (max-width: ${props => props.theme.screenXsMin}) {
    padding: ${paddingTop20px} 20px 30px;
  }
`;
